import {
  useUserContext 
} from "@/context/user"
import {
  useRouter 
} from "next/navigation"
import {
  useCallback, useEffect 
} from "react"

export const useSignInPage = (props) => {
  const {
    createAccountPageUrl = "/create-account",
    forgotPasswordPageUrl = "/forgot-password",
    signedInRedirectUrl = "/my-account",
  } = props
  const router = useRouter()
  const [{
    isSignedIn 
  }] = useUserContext()

  // Redirect if user is signed in
  useEffect(() => {
    if (isSignedIn) {
      if (signedInRedirectUrl) {
        router.push(signedInRedirectUrl)
      }
    }
  }, [router, isSignedIn, signedInRedirectUrl])

  const handleShowCreateAccount = useCallback(() => {
    if (createAccountPageUrl) {
      router.push(createAccountPageUrl)
    }
  }, [createAccountPageUrl, router])

  const handleShowForgotPassword = useCallback(() => {
    if (forgotPasswordPageUrl) {
      router.push(forgotPasswordPageUrl)
    }
  }, [forgotPasswordPageUrl, router])

  const signInProps = {
    classes: {
      modal_active: undefined 
    },
    showCreateAccount: handleShowCreateAccount,
    showForgotPassword: handleShowForgotPassword,
  }

  return {
    signInProps,
  }
}
